"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Range = void 0;
/**
 * A set of ordered Quantities defined by a low and high limit.
 */
var Range = /** @class */ (function () {
    function Range() {
    }
    return Range;
}());
exports.Range = Range;
